import { addDoc, collection, doc, getDoc, getDocs, limit, onSnapshot, query, serverTimestamp, setDoc, updateDoc, where } from 'firebase/firestore';
import { firestore } from '../../views/firebaseConfig';
import { defaultRace } from './raceRoomEngine';
const COL='quickRaces';
const firstText=(...values)=>values.find(v=>String(v||'').trim())||'';
const isPlainObject=value=>{
  if(value===null||typeof value!=='object')return false;
  const prototype=Object.getPrototypeOf(value);
  return prototype===Object.prototype||prototype===null;
};
const removeUndefined=value=>{
  if(Array.isArray(value))return value.filter(item=>item!==undefined).map(removeUndefined);
  if(isPlainObject(value)){
    return Object.fromEntries(
      Object.entries(value)
        .filter(([,item])=>item!==undefined)
        .map(([key,item])=>[key,removeUndefined(item)])
    );
  }
  return value;
};
export function listenRaces(uid,onData,onError){
  const q=query(collection(firestore,COL),where('participantUids','array-contains',uid),limit(50));
  return onSnapshot(q,s=>onData(s.docs.map(d=>({id:d.id,...d.data()}))),onError);
}
export async function loadPool4RealProfile(uid){
  if(!uid)return null;
  const snap=await getDoc(doc(firestore,'userprofiles',uid));
  if(!snap.exists())return null;
  const data=snap.data();
  return {uid:snap.id,...data,name:firstText(data.nickname,data.displayName,data.name,'Pool Player'),photoUrl:firstText(data.profileImageUrl,data.photoUrl),subtitle:[data.city,data.state].filter(Boolean).join(' • ')};
}
export async function searchPool4RealPlayers(currentUid,searchText){
  const token=String(searchText||'').trim().toLowerCase().split(/\s+/)[0];
  if(token.length<2)return [];
  const snap=await getDocs(query(collection(firestore,'userprofiles'),where('nickname_words','array-contains',token),limit(8)));
  return snap.docs.map(d=>({uid:d.id,...d.data()})).filter(p=>p.uid!==currentUid).map(p=>({uid:p.uid,name:firstText(p.nickname,p.displayName,p.name),photoUrl:firstText(p.profileImageUrl,p.photoUrl),subtitle:[p.city,p.state].filter(Boolean).join(' • '),isGuest:false})).filter(p=>p.name).sort((a,b)=>a.name.localeCompare(b.name));
}
export async function createRace(user,profile,settings={}){
  const savedProfile=profile||await loadPool4RealProfile(user.uid);
  const base=defaultRace({uid:user.uid,name:firstText(savedProfile?.nickname,savedProfile?.displayName,savedProfile?.name,'Player 1'),photoUrl:firstText(savedProfile?.profileImageUrl,savedProfile?.photoUrl)});
  const payload={...base,...settings,flow:{...base.flow,...settings.flow},display:{...base.display,...settings.display},matchBalance:{...base.matchBalance,...settings.matchBalance},timeCreated:serverTimestamp(),timeUpdated:serverTimestamp()};
  const ref=await addDoc(collection(firestore,COL),payload);return ref.id;
}
export async function saveRace(id,race){
  const {id:omit,...payload}=race;
  const cleanPayload=removeUndefined(payload);
  await setDoc(doc(firestore,COL,id),{...cleanPayload,timeUpdated:serverTimestamp()},{merge:true});
}
export async function patchRace(id,patch){await updateDoc(doc(firestore,COL,id),{...patch,timeUpdated:serverTimestamp()});}
export async function removeRace(id){await updateDoc(doc(firestore,COL,id),{status:'CANCELLED',timeUpdated:serverTimestamp()});}
